import { SportslinePickProps } from 'src/types';

export function getGameAbbr(gameInfo: Pick<SportslinePickProps['gameInfo'], 'awayTeam' | 'homeTeam' | 'isNeutral'>): string {
  if ([gameInfo, gameInfo?.homeTeam, gameInfo?.awayTeam].some(p => !Boolean(p))) {
    return '';
  }
  const versus = gameInfo.isNeutral ? ' vs. ' : ' @ ';
  return [gameInfo.awayTeam, gameInfo.homeTeam].map(team => team.abbrev).join(versus);
}

export const getLeagueRoutePath = (league: string) => {
  const cleanedLeague = (league || '').toLowerCase();
  if (Boolean(cleanedLeague)) {
    switch (cleanedLeague) {
      case 'cfb':
        return 'college-football';
      case 'cbb':
        return 'college-basketball';
      case 'wcs':
        return 'fifa-wc';
      default:
        return cleanedLeague;
    }
  }
  return cleanedLeague;
};
